module.exports = __webpack_public_path__ + "static/img/biobank-6.ffd8a8b422b9c0c9da61b6fbfcb63a14.png";